var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChallengesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Challenges Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Challenges-Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trophy-icon",
    transform: "translate(0.000000, 1.000000)",
    stroke: "#727272"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,0 C18.5522847,-1.08250786e-15 19,0.44771525 19,1 L19,6.5 C19,9.70940472 16.6739909,12.3755409 13.6157816,12.9045998 L13.615,17 L15.8461538,17 C16.3984386,17 16.8461538,17.4477153 16.8461538,18 L16.8461538,20 L18,20 C18.5522847,20 19,20.4477153 19,21 C19,21.5522847 18.5522847,22 18,22 L6,22 C5.44771525,22 5,21.5522847 5,21 C5,20.4477153 5.44771525,20 6,20 L7.15384615,20 L7.15384615,18 C7.15384615,17.4477153 7.6015614,17 8.15384615,17 L10.384,17 L10.3842184,12.9045998 C7.32600906,12.3755409 5,9.70940472 5,6.5 L5,1 C5,0.44771525 5.44771525,1.01453063e-16 6,0 L18,0 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,2 L2.5,2 C3.05228475,2 3.5,2.44771525 3.5,3 L3.5,4.5 C3.5,5.88071187 2.38071187,7 1,7 L0.5,7 L0.5,7",
    id: "Rectangle",
    strokeLinecap: "round",
    transform: "translate(2.000000, 4.500000) scale(-1, 1) translate(-2.000000, -4.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,2 L22.5,2 C23.0522847,2 23.5,2.44771525 23.5,3 L23.5,4.5 C23.5,5.88071187 22.3807119,7 21,7 L20.5,7 L20.5,7",
    id: "Rectangle",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star",
    points: "12 7.80656098 10.2366442 8.42705098 10.2818584 6.55825804 9.14683045 5.07294902 10.9381301 4.53846146 12 3 13.0618699 4.53846146 14.8531695 5.07294902 13.7181416 6.55825804 13.7633558 8.42705098"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallengesIcon);
export default __webpack_public_path__ + "static/media/Challenges-Icon.fa55bc3f2d9109adbff1ac313d5c91a5.svg";
export { ForwardRef as ReactComponent };